<template>
<div>
	<!-- <b-modal  size="xl" v-model="open_tree_modal" @hide="closeTreeModal" @cancel="closeTreeModal"> -->
		<div class="row ml-2 mb-2">
				<div class="list-wrapper">
					<div class="list-background" v-if="accessList != ''">
						<list-view-group-tree :label="'Custom'" :selected_id="selected_list" 
						:selection="selection"
						:accessList="accessList.custom" @selectItem="selectItem" :key="'Custom'"/>
						<list-view-group-tree
						:label="'Location'" :selected_id="selected_list" 
						:selection="selection"
						:accessList="accessList.auto['Location']" @selectItem="selectItem" :key="'Location'"/>
						<list-view-group-tree :label="'Discipline'" :selected_id="selected_list" 
						:selection="selection"
						:accessList="accessList.auto['Discipline']" @selectItem="selectItem" :key="'Discipline'"/>
						

				</div>
			</div>
				<div class="cart-resize mr-2">
					<!-- <TreeChart :json="treeData" @click-node="clickNode" /> -->
					<v-select class="mb-2 mt-2"  :searchable="true" multiple 
						label="name" v-model="selected_list" :options="selected_list">
					</v-select>
					<input placeholder="Access Group Name" type="text" class="form-control"  name="first_name" v-model="access_group.name">
					<button type="submit" :disabled="submit_disabled" class="button large-button mt-2 float-right" :class="{'disabled-button':submit_disabled}" @click="createGroup">Create</button>
				</div>
		</div>
	<!-- </b-modal> -->
</div>
	
</template>
<script>

import ListViewGroupTree from "../shared/ListViewGroupTree";
export default {
	components: {
    	ListViewGroupTree
	},
	data : function(){

		return{
			access_group:{
				name:'',
				access_groups:[]
			},
			open_tree_modal:true,
			accessList:'',
			listTypes:['Custom', 'Location', 'Discipline'],
			listData:[],
			selected_list:[],
			show_list:true,
			selection:{
				  type:'',
				  name:'',
				  id:''
			  },
		}
	},
	computed:{
		submit_disabled: function(){
			return (this.selected_list.length == 0 || this.access_group.name == '')
		},
		current_agency(){
			return this.$route.params.agency_id
		}
	},
	created : function(){
		this.getAccessList()
	},
	methods : {
		getAccessList : function(){
			var params = {
				filters:{
					organization_id : this.current_agency,
				}
			}
			this.$store.dispatch('getAccessList',params).then((res)=>{
				this.accessList = res.data.data

            }).catch((error) => {
              // window.location.reload()
            })

		},
		selectItem: function(elem){
			if(this.selected_list.includes(elem)){
				this.selected_list = this.selected_list.filter((li,index) =>{
					return li.id != elem.id
				})
			}else{
				this.selection = elem
				this.selected_list.push(elem)
			}
		},
		createGroup: function(){
			var params = {
				filters:{
					organization_id : this.current_agency,
				},
				name: this.access_group.name, 
				access_groups: this.selected_list.map(elem => elem.id),
				
			}
			this.$store.dispatch('postAccessList',params).then((res)=>{
				this.cleanUserAcessGroupData();
				this.getAccessList();

            }).catch((error) => {
				console.log(error)
            })
		},
		cleanUserAcessGroupData: function(){
			this.access_group = {
				name:'',
				access_groups:[]
			}
			this.selected_list = []
		}
	}
}

</script>
<style scoped src="../shared/assets/css/groupAccessList.css">

</style>



// WEBPACK FOOTER //
// src/components/shared/AccessGroupTree.vue